/* eslint-disable func-names */
import * as Yup from 'yup';

export default Yup.object().shape({
  date: Yup.date('SCHEMA_ERRORS.REQUIRED_FIELD').required(
    'SCHEMA_ERRORS.REQUIRED_FIELD'
  ),
  paymentForm: Yup.string().required('SCHEMA_ERRORS.REQUIRED_FIELD'),
  series: Yup.string().required('SCHEMA_ERRORS.REQUIRED_FIELD'),
  cfdis: Yup.array().test(
    'cfdis',
    'SCHEMA_ERRORS.NEED_MINIMUM_ONE_CFDI',
    function(value) {
      const errors = [];
      const withCfdi = value.filter(row => row.cfdi);
      if (withCfdi.length === 0) {
        errors.push(
          this.createError({
            path: 'cfdis',
            message: 'SCHEMA_ERRORS.NEED_MINIMUM_ONE_CFDI'
          })
        );
      }
      for (let i = 0; i < value.length; i++) {
        const row = value[i];
        if (!row.cfdi) {
          continue;
        }
        if (row.amount <= 0) {
          errors.push(
            this.createError({
              path: `cfdis[${i}]`,
              message: 'SCHEMA_ERRORS.VALUE_GREATER_THAN_ZERO'
            })
          );
        }
        if (row.amount > row.cfdi.amountIvaIncluded) {
          errors.push(
            this.createError({
              path: `cfdis[${i}]`,
              message:
                'SCHEMA_ERRORS.AMOUNT_TO_PAY_MUST_BE_LESS_THAN_OR_EQUAL_TO_AMOUNT_IVA_INCLUDED'
            })
          );
        }
      }

      if (errors.length > 0) {
        return new Yup.ValidationError(errors);
      }
      return true;
    }
  )
});
